import qs from 'query-string';

export function parseSearch(search) {
    return qs.parse(search);
}

export function serializeSearchParams(params, options = {}) {
    return qs.stringify(params, options);
}
